import * as devisConf from '@/configuration/devisConf';

function ligneCommandeByReferenceEcheancier(lignesCommandes, reference) {
  const toutesLigneCommande = [];

  lignesCommandes.forEach(lc => {
    toutesLigneCommande.push(lc);
    if (lc.lignesCommande) {
      lc.lignesCommande.forEach(lnc => {
        lnc.produitParent = lc.produit;
        toutesLigneCommande.push(lnc);
      });
    }
  });
  const ligneCommande = [];

  toutesLigneCommande
    .sort((a, b) => {
      return +a.ordre - +b.ordre;
    })
    .filter(ligne => ligne.type === devisConf.NORMAL
    && ligne.referenceEcheancier === reference)
    .forEach(ln => {
      ligneCommande.push({
        libelle: ln.libelle,
        produit: ln.produitParent ? ln.produitParent : null,
      });
    });

  return ligneCommande;
}

export default function libelleEcheance(lignesCommandes, referenceEcheance) {
  let libelle = '';

  const ligneCommande = ligneCommandeByReferenceEcheancier(
    lignesCommandes, referenceEcheance,
  );
  if (ligneCommande.length > 0) {
    let referencePrecedente = '';
    ligneCommande.forEach(ligneCmd => {
      if (ligneCmd.produit === null) {
        if (libelle !== '') { libelle += ' / '; }
        libelle += ligneCmd.libelle;
      } else {
        if (referencePrecedente === ligneCmd.produit.reference) {
          libelle += ', ' + ligneCmd.libelle;
        } else {
          if (libelle !== '') { libelle += ' / '; }
          libelle += ligneCmd.produit.reference + ' ' + ligneCmd.libelle;
        }
        referencePrecedente = ligneCmd.produit.reference;
      }
    });
  }
  return libelle;
}
